import React from 'react';
import { connect } from 'react-redux';
import NotFoundView from './not-found-view';
import resolveRoute from 'lib/resolve-route';

export const NotFoundContainer = () => <NotFoundView rootUrl={resolveRoute.resolve('root')} />;

export default connect<{}, {}, {}, ApplicationShape>(null)(NotFoundContainer);
